import CountdownClock from '@rsa-digital/evo-shared-components/components/CountdownClock';
import { graphql } from 'gatsby';
import React, { useEffect } from 'react';

export type CountdownClockBlockProps = {
  countdown_clock: {
    heading: string;
    event_in_progress_heading: string;
    event_finished_heading: string;
    starting_date: string;
    event_end_date: string;
  };
};

export const query = graphql`
  fragment CountdownClockBlock on cs__countdown_clock {
    heading
    event_in_progress_heading
    event_finished_heading
    starting_date
    event_end_date
  }
`;

const CountdownClockBlock: React.FC<CountdownClockBlockProps> = ({ countdown_clock }) => {
  const [eventStartDate, setEventStartDate] = React.useState<Date>(new Date());
  const [eventEndDate, setEventEndDate] = React.useState<Date>(new Date());

  useEffect(() => {
    setEventStartDate(new Date(countdown_clock.starting_date));
    setEventEndDate(new Date(countdown_clock.event_end_date));
  }, [countdown_clock.starting_date, countdown_clock.event_end_date]);

  return (
    <CountdownClock
      data-cy="CountdownClock"
      eventUpcomingHeading={countdown_clock.heading}
      eventInProgressHeading={countdown_clock.event_in_progress_heading}
      eventFinishedHeading={countdown_clock.event_finished_heading}
      eventStartDate={eventStartDate}
      eventEndDate={eventEndDate}
    />
  );
};

export default React.memo(CountdownClockBlock);
